const { useState, useMemo } = require("react")

/**
 * @typedef {Object} Filter
 */

const useFilters = (meals) => {
  const [ activeFilters, setActiveFilters ] = useState([]);
  const filterCategories = useMemo(() => {
    const allTags = meals.map(meal => meal.tags).flat();
    const uniqueTags = Array.from(new Set(allTags));
    const filteredTags = uniqueTags.filter(tag => tag.toLowerCase().startsWith('filter:'));

    // Creating categories and adding filter values
    const categories = new Map();
    for (const tag of filteredTags) {
      const parts = tag.replace(/^[Ff]ilter:/, '').trim().split('|');
      let [ category, value ] = parts.length > 1
        ? parts
        : ['General', parts[0]];
      category = category.trim();
      value = value.trim();

      const c = categories.get(category) ?? new Set();
      categories.set(category, c);
      c.add(value);
    }

    // Creating array of categories and sorting them
    return Array.from(categories.entries()).map(([ category, filters ]) => ({
      category,
      values: Array.from(filters).sort(),
    })).sort((a, b) => a.category.localeCompare(b.category));
  }, [meals]);
  const filteredMeals = useMemo(() => {
    if (activeFilters.length === 0) return meals;
    return meals.filter(meal => activeFilters.every(({ category, value }) => {
      const filterTags = [];
      let prefix = `${category}|`;
      if (category === 'General') {
        prefix = '';
      }
      filterTags.push(`Filter: ${prefix}${value}`);
      filterTags.push(`filter: ${prefix}${value}`);
      filterTags.push(`Filter:${prefix}${value}`);
      filterTags.push(`filter:${prefix}${value}`);

      return filterTags.some(filterTag => meal.tags.includes(filterTag));
    }));
  }, [meals, activeFilters]);
  const sortedFilteredMeals = useMemo(() => {
    return filteredMeals.sort((a, b) => {
      const aPriority = parseInt(a.tags.find(tag => tag.startsWith('priority:'))?.split(':')?.[1] ?? '2147483647');
      const bPriority = parseInt(b.tags.find(tag => tag.startsWith('priority:'))?.split(':')?.[1] ?? '2147483647');

      return aPriority - bPriority;
    });
  }, [filteredMeals]);

  return {
    all: filterCategories,
    active: activeFilters,
    meals: sortedFilteredMeals,
    set: setActiveFilters,
  }
}

export default useFilters;